import React from "react";
import { Row, Col } from "react-bootstrap";
import { FiShield } from "react-icons/fi";

const BankStatusSection = ({ formData, setFormData, handleChange }) => {
  return (
    <div className="bma-card">
      <div className="bma-card-body">
        <div className="d-flex align-items-center gap-2 mb-3">
          <div className="bma-icon-circle green"><FiShield /></div>
          <h2 className="bma-card-title">4. Status</h2>
        </div>
        <Row className="g-3">
          <Col md={4}>
            <label className="bma-label">Status <span className="req">*</span></label>
            <div className="d-flex gap-2 mt-1">
              <button
                type="button"
                className={`bma-status-btn ${formData.status === "Active" ? "active-success" : ""}`}
                onClick={() => setFormData((p) => ({ ...p, status: "Active" }))}
              >
                Active
              </button>
              <button
                type="button"
                className={`bma-status-btn ${formData.status === "Inactive" ? "active-danger" : ""}`}
                onClick={() => setFormData((p) => ({ ...p, status: "Inactive" }))}
              >
                Inactive
              </button>
            </div>
          </Col>
          <Col md={8}>
            <label className="bma-label">Remarks (Optional)</label>
            <textarea
              rows={2}
              name="remarks"
              className="bma-textarea"
              placeholder="Enter remarks"
              value={formData.remarks}
              onChange={handleChange}
              maxLength={250}
            />
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default BankStatusSection;